import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/Services/loader.service';
import { WebsiteService } from 'src/app/Services/website.service';
import { appConfig } from 'src/app/app.config';

@Component({
  selector: 'app-bc-focus',
  templateUrl: './bc-focus.component.html',
  styleUrls: ['./bc-focus.component.css']
})
export class BcFocusComponent implements OnInit {

  base_address: string = appConfig.apiUrl + 'admin/';
  kpistatues:any;
  bcDetails:any;

  KpiId:any;
  BcId:any;
  year:any;
  quarter:any;

  constructor(private route: ActivatedRoute,
    private loader: LoaderService,
    private websiteser: WebsiteService) {
      this.BcId = this.route.snapshot.params['bcid'];
      this.KpiId = this.route.snapshot.params['kpiId'];
      this.year = this.route.snapshot.params['year'];
      this.quarter = this.route.snapshot.params['quarter'];
  
    }

  ngOnInit() {

    setTimeout(() => {
      this.loader.hideLoader();
    }, 300);

    this.bcDetails = this.route.snapshot.data.data.result;
    this.kpistatues = this.route.snapshot.data.status.result;
  }

  getArrow(first, second){
    let html = '<img src="';
    if(second == -1 || first == -1){
      return html += 'assets/imgs/right.png" class="horizontal">'
    }
    if(second < first){
      return html += 'assets/imgs/up.png" class="vertical">'
    }
    else if(second > first){
      return html += 'assets/imgs/down.png" class="vertical">'
    }
    else{
      return html += 'assets/imgs/right.png" class="horizontal">'
    }
  }

}
